import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const UserProtectedRoutes = ({ children }) => {
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.user.token);
  const accountType = useSelector((state) => state.account?.accountType);

  useEffect(() => {
    if (!isAuthenticated || accountType !== "real") {
      // Redirect to home if not authenticated or account type isn't "real"
      navigate("/");
    }
  }, [isAuthenticated, accountType, navigate]);

  // Only render children if the user is authenticated and the accountType is "real"
  if (isAuthenticated && accountType === "real") {
    return <>{children}</>;
  } else {
    navigate("/");
  }

  // Optionally return a fallback component, like a loading spinner or message
  return null;
};

export default UserProtectedRoutes;
